import React from 'react';
import PropTypes from 'prop-types';
import { LuFileSpreadsheet, LuFileText, LuFolderX, LuHandshake, LuLoaderCircle, LuPlus } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useTariffText from '../tariffText';

/** Title card of Alt Yüklenici / Tarife Yönetimi with the page actions. */
const TariffHeader = ({ withoutTariffsCount, onShowWithoutTariffs, isExporting, onExcel, onPdf, onAdd }) => {
  const { label } = useTariffText();
  const iconButton = 'max-sm:tw-w-10 max-sm:tw-px-0';
  const exportIcon = (Icon, tone) => (isExporting
    ? <LuLoaderCircle aria-hidden="true" className="tw-h-4 tw-w-4 tw-animate-spin" />
    : <Icon aria-hidden="true" className={`tw-h-4 tw-w-4 ${tone}`} />);
  return (
    <PageHero
      icon={LuHandshake}
      gradient="tw-from-indigo-400 tw-to-violet-600 tw-shadow-violet-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      // Phones: "new tariff" across the row, the rest as icon buttons; wider
      // screens wrap instead of running out of the card
      actionsClassName="tw-grid tw-grid-cols-[repeat(3,auto)_minmax(0,1fr)] tw-items-center tw-gap-2 sm:tw-flex sm:tw-flex-wrap lg:tw-max-w-[calc(100%-22rem)] lg:tw-justify-end"
    >
      <Button onClick={onShowWithoutTariffs} aria-label={label('actions.withoutTariffs')} title={label('actions.withoutTariffsHint')} className={iconButton}>
        <LuFolderX aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-amber-600 dark:tw-text-amber-300" />
        <span className="tw-hidden sm:tw-inline">{label('actions.withoutTariffs')}</span>
        {/* Count beside the label (buttons clip overflow); phones see it on the stat tile */}
        {withoutTariffsCount > 0 && (
          <span className="tw-hidden tw-h-5 tw-min-w-[1.25rem] tw-place-items-center tw-rounded-full tw-bg-amber-500 tw-px-1.5 tw-text-[10px] tw-font-bold tw-leading-none tw-text-white tw-tabular-nums sm:tw-grid">
            {withoutTariffsCount}
          </span>
        )}
      </Button>
      <Button onClick={onExcel} disabled={isExporting} aria-label={label('actions.excel')} title={label('actions.excelHint')} className={iconButton}>
        {exportIcon(LuFileSpreadsheet, 'tw-text-emerald-600 dark:tw-text-emerald-400')}
        <span className="tw-hidden sm:tw-inline">{isExporting ? label('actions.preparing') : label('actions.excel')}</span>
      </Button>
      <Button onClick={onPdf} disabled={isExporting} aria-label={label('actions.pdf')} title={label('actions.pdfHint')} className={iconButton}>
        {exportIcon(LuFileText, 'tw-text-rose-600 dark:tw-text-rose-400')}
        <span className="tw-hidden sm:tw-inline">{isExporting ? label('actions.preparing') : label('actions.pdf')}</span>
      </Button>
      <Button variant="primary" onClick={onAdd} className="max-sm:tw-w-full">
        <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" strokeWidth={2.5} />
        {label('actions.add')}
      </Button>
    </PageHero>
  );
};

TariffHeader.propTypes = {
  withoutTariffsCount: PropTypes.number.isRequired,
  onShowWithoutTariffs: PropTypes.func.isRequired,
  isExporting: PropTypes.bool,
  onExcel: PropTypes.func.isRequired,
  onPdf: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default TariffHeader;
